import { FLEET_MAP_MAX_TEXT_LENGTH, type FleetMapCspViolation } from '@bonbon/types';

function clip(text: string): string {
  return text.slice(0, FLEET_MAP_MAX_TEXT_LENGTH);
}

/**
 * The reportable part of a `securitypolicyviolation` event. Text is clipped to
 * what the host accepts, and the event's `sample` (which can hold script text)
 * is left out on purpose.
 */
export function toCspViolation(event: SecurityPolicyViolationEvent): FleetMapCspViolation {
  return {
    violatedDirective: clip(event.violatedDirective),
    effectiveDirective: clip(event.effectiveDirective),
    blockedUri: clip(event.blockedURI),
    documentUri: clip(event.documentURI),
    sourceFile: event.sourceFile === '' ? null : clip(event.sourceFile),
    lineNumber: event.lineNumber > 0 ? event.lineNumber : null,
    columnNumber: event.columnNumber > 0 ? event.columnNumber : null,
    disposition: event.disposition === 'report' ? 'report' : 'enforce',
  };
}

/** A repeat of the same block adds nothing for the host to log. */
export function cspViolationKey(violation: FleetMapCspViolation): string {
  return `${violation.effectiveDirective}|${violation.blockedUri}`;
}

/** Most distinct violations forwarded in one page's life. */
export const MAX_FORWARDED_VIOLATIONS = 25;
